import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

export type PpeDetectionMetadata = {
  missing_hat: boolean;
  missing_vest: boolean;
  missing_safetyharness: boolean;
  missing_facemask: boolean;
  missing_boots: boolean;
  missing_gloves: boolean;
  missing_lifevest: boolean;
  missing_carabiner: boolean;
};
export type FireSmokeMetadata = {
  fire: boolean;
  smoke: boolean;
};

export type MetadataFilters = keyof AlertMetadataState;

export type VehicleTypeFilters = Extract<
  MetadataFilters,
  | 'illegal_parking'
  | 'worker_near_heavy_machine'
  | 'speeding'
  | 'unenclosed_machinery'
>;

export type AlertMetadataState = {
  ppe_detection: PpeDetectionMetadata;
  fire_smoke_detection: FireSmokeMetadata;
  worker_near_heavy_machine: string[];
  illegal_parking: string[];
  speeding: string[];
  unenclosed_machinery: string[];
  worker_under_load: string[];
};

const initialState: AlertMetadataState = {
  ppe_detection: {
    missing_hat: false,
    missing_vest: false,
    missing_safetyharness: false,
    missing_facemask: false,
    missing_boots: false,
    missing_gloves: false,
    missing_lifevest: false,
    missing_carabiner: false,
  },
  fire_smoke_detection: {
    fire: false,
    smoke: false,
  },
  worker_near_heavy_machine: [],
  illegal_parking: [],
  speeding: [],
  unenclosed_machinery: [],
  worker_under_load: [],
};

const alertMetadataFilterSlice = createSlice({
  name: 'alertMetadataFilter',
  initialState,
  reducers: {
    updatePpeDetectionFilters: (
      state,
      action: PayloadAction<PpeDetectionMetadata>,
    ) => {
      state.ppe_detection = action.payload;
    },
    updateFireSmokeFilters: (
      state,
      action: PayloadAction<FireSmokeMetadata>,
    ) => {
      state.fire_smoke_detection = action.payload;
    },
    updateWorkerUnderLoadFilters: (state, action: PayloadAction<string[]>) => {
      state.worker_under_load = action.payload;
    },

    updateVehicleTypesFilters: (
      state,
      action: PayloadAction<{
        values: string[];
        type: VehicleTypeFilters;
      }>,
    ) => {
      const { values, type } = action.payload;
      state[type] = values;
    },

    resetAlertMetadataFilters: () => initialState,
  },
});

export const getAlertMetadataFilters = (state: RootState) =>
  state.alertMetadataFilter;

export const {
  updatePpeDetectionFilters,
  updateFireSmokeFilters,
  updateWorkerUnderLoadFilters,
  resetAlertMetadataFilters,
  updateVehicleTypesFilters,
} = alertMetadataFilterSlice.actions;

export default alertMetadataFilterSlice.reducer;
